@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if ($.row && $.adata.fetch_key) {
    <span>
      {{ getMode($.row[$.adata.fetch_key], $.row) }}
      @if ($.row.is_online) {
        <i
          class="fa fa-globe text-sm ml-1 cursor-pointer"
          pTooltip="This is an Online Payment"
          tooltipPosition="top"
          aria-label="online-payment-indicator"
        ></i>
      }
    </span>
  } @else {
    --
  }
}
